import Vue, { DirectiveOptions } from 'vue';
import { initializer as bootstrap, PluginsExtened, configService, CrossDomainSync } from '@tencent/s2-client-vue-lib';
import Promise from 'es6-promise';

import 'normalize.css';
import ElementUI from 'element-ui';
import SvgIcon from 'vue-svgicon';
import 'element-ui/lib/theme-chalk/index.css';

import '@/styles/index.scss';

import App from '@/App.vue';
import store from '@/store';
import { appModule } from '@/store/modules/ModuleApp';
import router from '@/router';
import i18n from '@/lang';
import '@/assets/icons/components';
import permission from '@/AppPermission';
import '@/service/ServiceErrorLog';

import ConfigDev from './config/ConfigDev';
import ConfigTest from './config/ConfigTest';
import ConfigProd from './config/ConfigProd';
import {
	formatTime,
	formatSecondTime,
	numberFilter,
	priceFilter,
	AppCustomMessager,
	emailAppendFilter,
	workWithNumberFilter,
	formatTimeWithLocale
} from './AppDecorater';
import moment from 'moment';
import CustomSelector from '@/components/selector/index.vue';
import { getRequireLevelDescByValue, CROSS_DOMAIN_SYNC_OPTIONS, CROSS_DOMAIN_KEY_VENDOR_FULL_VALUE } from './libs/LibsStatus';
import VueClipboard from 'vue-clipboard2';
import WatcherMarker from '@/directives/DirectiveWaterMarker';
import PermissionAction from '@/directives/DirectivePermissionAction';

Promise.polyfill();

Vue.use(ElementUI, {
	size: appModule.size,
	i18n: (key: string, value: string): any => i18n.t(key, value)
});

Vue.use(SvgIcon, {
	tagName: 'svg-icon',
	defaultWidth: '1em',
	defaultHeight: '1em'
});

/**
 * CrossDomainSync 实例，用于跨域/跨 Tab 数据共享
 */
const sync: any = new CrossDomainSync(CROSS_DOMAIN_SYNC_OPTIONS);
configService.setCustomHeadersGetter(() => ({
	'pvendor-id': sync.get(CROSS_DOMAIN_KEY_VENDOR_FULL_VALUE) || ''
}));

// 自定义下拉组件
Vue.component(CustomSelector.name, CustomSelector);

// 注册自定义过滤器
Vue.filter('priceFilter', priceFilter);
Vue.filter('workWithNumberFilter', workWithNumberFilter);
Vue.filter('numberFilter', numberFilter);
Vue.filter('formatTime', formatTime);
Vue.filter('formatTimeWithLocale', formatTimeWithLocale);
Vue.filter('formatSecondTime', formatSecondTime);
Vue.filter('emailAppend', emailAppendFilter);

// 需求等级影射
Vue.filter('getRequireLevelDescByValue', getRequireLevelDescByValue);

// 时间组件
Vue.prototype.$moment = moment;

// 注入全局自定义插件(包含自定义过滤器、指令、混入项等)
Vue.use(new PluginsExtened());

Vue.config.productionTip = false;

// 复制插件
Vue.use(VueClipboard);

// 注册水印指令
Vue.directive('watermarker', WatcherMarker);
// 注册权限指令
Vue.directive('action', PermissionAction);

// 重写提示类
Vue.prototype.$message = new AppCustomMessager();

// 环境变量前缀
const envPerfix: string | undefined = process.env.VUE_APP_ENV_PERFIX === '/' ? '' : process.env.VUE_APP_ENV_PERFIX;
const cdnPerfix: string | undefined = process.env.VUE_APP_CDN_PERFIX === '/' ? '' : process.env.VUE_APP_CDN_PERFIX;
console.log('envPerfix ==>', envPerfix);
console.log('cdnPerfix ==>', cdnPerfix);
Vue.prototype.envPerfix = envPerfix;

// cdn前缀
Vue.prototype.cdnPerfix = cdnPerfix;

// 获取公共cdn前缀
Vue.prototype.getResource = (path: string) => `${cdnPerfix}${path}`;

new Vue({
	router,
	store,
	i18n,
	/**
	 * created
	 * @returns {*}
	 */
	created(): any {
		bootstrap(ConfigDev, ConfigTest, ConfigProd, ConfigProd, ConfigProd, i18n, Vue).then((v: any): any => {
			permission.sumilateLogin();
		});
	},

	render: (h: any): any => h(App)
}).$mount('#app');
